import React, { useState, useMemo, useEffect } from "react";
import { FormControl, FormGroup, FormHelperText, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import {
  TkfacilitySelectionProps,
  Facility,
  TableHeader,
} from "../../../type/componentsType/TkFacilityselection";
import {
  facilitiesfields,
  facilityHeadfields,
  facilityLoopListAll,
} from "../../../assets/data/TkFacilitySelectionProperty";
import { TkTable } from "../../atoms/TkTable";
import { TkModalButton } from "../TkModalButton";
import { TkAccordion } from "../../atoms/TkAccordion";
import { TkRadio } from "../../atoms/TkRadio";
import TkCheckbox from "../../atoms/TkCheckbox";
import "./_style.scss";

const AllFacilities: Facility[] = facilitiesfields.facilities.AllFacilities;

const facilityHeads1readonly = facilityHeadfields.facilities.facilityHeads1;
let facilityHeads1 = [...facilityHeads1readonly];
//isSCRC030001がtrueの場合のheadList
let headList1 = facilityHeads1.map((item) => {
  return { headTitle: item.name };
});

const facilityHeads2readonly = facilityHeadfields.facilities.facilityHeads2;
let facilityHeads2 = [...facilityHeads2readonly];
//isSCRC030001がfalseの場合のheadList
let headList2 = facilityHeads2.map((item) => {
  return { headTitle: item.name };
});

const facilityHeads3readonly = facilityLoopListAll.facilities.facilityLoopList;
let facilityLoopList = [...facilityHeads3readonly];
//Accordionの項目を詰めたList
let LoopList = facilityLoopList.map((item) => {
  return { AccordionHead: item.name };
});

const NoSelectFacilityList = {
  id: 0,
  category: "",
  partitioncode: "",
  partitioncodename: "",
  typecode: "",
  name: "",
};

function getReturnListByTypecode(wantToSetValue: any) {
  const allFacilities = facilitiesfields.facilities.AllFacilities;
  const matchedFacility = allFacilities.find(
    (facility) => facility.typecode === wantToSetValue
  );
  return matchedFacility ? matchedFacility : NoSelectFacilityList;
}

function getReturnListById(checkedFacilityId: any) {
  const allFacilities = facilitiesfields.facilities.AllFacilities;
  const matchedFacility = allFacilities.find(
    (facility) => facility.id === checkedFacilityId
  );
  return matchedFacility ? matchedFacility : NoSelectFacilityList;
}

/**
 * 施設選択部品
 * 選択ボタン押下後、施設種類選択ダイアログを表示する
 * ダイアログ内の施設を選択し閉じると選択ボタンの横に選択した種類が出力される。
 * @param {boolean}isSCRC030001 SCRC030001フラグ
 * @param {boolean}isResisterApplyFlg //画面が登録申請か判断するフラグ(登録申請の場合(true)はisSCRC030001がfalseでも申出施設を表示しない,falseは表示する。)
 * @return TkFacilitySelection 施設選択部品
 */
export const TkFacilitySelection: React.FC<TkfacilitySelectionProps> = ({
  isSCRC030001 = true,
  disabled,
  onChange,
  wantToSetValue,
  getFacilityList,
  isResisterApplyFlg = false, //画面が登録申請か判断するフラグ(登録申請の場合(true)はisSCRC030001がfalseでも申出施設を表示しない,falseは表示する。)
  ...rest
}) => {
  const [open, setOpen] = useState(false);
  const [checkedFacilityId, setCheckedFacilityId] = useState<number>(0);
  const [checkedFacilityIds, setCheckedFacilityIds] = useState<number[]>([]);
  const [returnedFacilityId, setReturnedFacilityId] = useState<number>(0);
  const [returnedFacilityIds, setReturnedFacilityIds] = useState<number[]>([]);
  const [FacilityHead, setFacilityHead] = useState<TableHeader[]>([]);

  useEffect(() => {
    setReturnedFacilityId(wantToSetValue || "");

    if (wantToSetValue) {
      let returnFacilityList = getReturnListByTypecode(wantToSetValue);
      setReturnedFacilityId(returnFacilityList?.id);
      getFacilityList && getFacilityList(returnFacilityList);

      const defaultValue = {
        target: {
          value: wantToSetValue,
        },
      } as React.ChangeEvent<HTMLInputElement>;
      onChange && onChange(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantToSetValue]);

  const handleOpenModal = () => {
    if (isSCRC030001) {
      setCheckedFacilityIds([...returnedFacilityIds]);
      setFacilityHead(headList1);
      setOpen(true);
    } else if (!isSCRC030001 && isResisterApplyFlg) {
      setCheckedFacilityId(returnedFacilityId);
      setFacilityHead(headList1);
      setOpen(true);
    } else {
      setCheckedFacilityId(returnedFacilityId);
      setFacilityHead(headList2);
      setOpen(true);
    }
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, value } = event.target;
    const facilityId = parseInt(value, 10);
    if (isSCRC030001) {
      if (checked) {
        setCheckedFacilityIds((prevState) => [...prevState, facilityId]);
      } else {
        setCheckedFacilityIds((prevState) =>
          prevState.filter((id) => id !== facilityId)
        );
      }
    } else {
      let valueNum = Number(value);
      setCheckedFacilityId((prevState) =>
        prevState === valueNum ? 0 : facilityId
      );
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault(); // デフォルトのRadioボタンの動作を防ぎます
    handleChange(event as unknown as React.ChangeEvent<HTMLInputElement>); // クリックイベントを変更イベントとして扱います
  };

  const handleSave = () => {
    if (isSCRC030001) {
      setReturnedFacilityIds([...checkedFacilityIds]);
      onChange && onChange({ target: { value: checkedFacilityIds } });
      setOpen(false);
    } else {
      setReturnedFacilityId(checkedFacilityId);
      onChange && onChange({ target: { value: checkedFacilityId } });

      let returnOutputList = getReturnListById(checkedFacilityId);
      getFacilityList && getFacilityList(returnOutputList);
      setOpen(false);
    }
  };

  const selectedFacilityNames = useMemo(() => {
    const facilities: Facility[] = [...AllFacilities];
    if (isSCRC030001) {
      return facilities
        .filter((facility) => returnedFacilityIds.includes(facility.id))
        .map((facility) => facility.name)
        .join("、");
    } else {
      return facilities
        .filter((facility) => returnedFacilityId === facility.id)
        .map((facility) => facility.name);
    }
  }, [returnedFacilityIds, returnedFacilityId, isSCRC030001]);

  return (
    <Box className="facilitySelection">
      <TkModalButton
        open={open}
        data-testid="tkModalForTest"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        menu="をクリックすると施設の種類が表示されます。"
        handleSave={handleSave}
        handleCloseModal={handleCloseModal}
        handleOpenModal={handleOpenModal}
        buttonlefttext={"選択して閉じる"}
        buttonrighttext={"キャンセル"}
        selectedNames={selectedFacilityNames}
        disabled={disabled}
      >
        <FormControl
          sx={{
            m: 3,
            display: "flex",
          }}
          component="fieldset"
          variant="standard"
          data-testid="tkFacilitySelectionForTest"
        >
          {LoopList.map((LoopList, index) => (
            <Box key={index}>
              {isSCRC030001 ? (
                <TkAccordion title={LoopList.AccordionHead}>
                  <TkTable
                    bodyList={[
                      [
                        {
                          children: (
                            <>
                              <FormGroup>
                                {AllFacilities.filter(
                                  (AllFacilities) =>
                                    AllFacilities.category ===
                                      LoopList.AccordionHead &&
                                    AllFacilities.partitioncode === "1"
                                ).length > 0 ? (
                                  AllFacilities.filter(
                                    (AllFacilities) =>
                                      AllFacilities.category ===
                                        LoopList.AccordionHead &&
                                      AllFacilities.partitioncode === "1"
                                  ).map((AllFacilities) => (
                                    <TkCheckbox
                                      key={AllFacilities.id}
                                      checked={checkedFacilityIds.includes(
                                        AllFacilities.id
                                      )}
                                      onChange={handleChange}
                                      value={AllFacilities.id.toString()}
                                      label={AllFacilities.name}
                                    />
                                  ))
                                ) : (
                                  <Typography>該当なし</Typography>
                                )}
                              </FormGroup>
                            </>
                          ),
                          align: "left",
                        },
                        {
                          align: "left",
                          children: (
                            <>
                              <FormGroup>
                                {AllFacilities.filter(
                                  (AllFacilities) =>
                                    AllFacilities.category ===
                                      LoopList.AccordionHead &&
                                    AllFacilities.partitioncode === "3"
                                ).length > 0 ? (
                                  AllFacilities.filter(
                                    (AllFacilities) =>
                                      AllFacilities.category ===
                                        LoopList.AccordionHead &&
                                      AllFacilities.partitioncode === "3"
                                  ).map((AllFacilities) => (
                                    <TkCheckbox
                                      key={AllFacilities.id}
                                      checked={checkedFacilityIds.includes(
                                        AllFacilities.id
                                      )}
                                      onChange={handleChange}
                                      value={AllFacilities.id.toString()}
                                      label={AllFacilities.name}
                                    />
                                  ))
                                ) : (
                                  <Typography>該当なし</Typography>
                                )}
                              </FormGroup>
                            </>
                          ),
                        },
                      ],
                    ]}
                    headList={FacilityHead}
                  />
                </TkAccordion>
              ) : !isSCRC030001 && isResisterApplyFlg ? (
                <TkAccordion title={LoopList.AccordionHead}>
                  <TkTable
                    bodyList={[
                      [
                        {
                          children: (
                            <>
                              <FormGroup>
                                {AllFacilities.filter(
                                  (AllFacilities) =>
                                    AllFacilities.category ===
                                      LoopList.AccordionHead &&
                                    AllFacilities.partitioncode === "1"
                                ).length > 0 ? (
                                  AllFacilities.filter(
                                    (AllFacilities) =>
                                      AllFacilities.category ===
                                        LoopList.AccordionHead &&
                                      AllFacilities.partitioncode === "1"
                                  ).map((AllFacilities) => (
                                    <TkRadio
                                      key={AllFacilities.id}
                                      checked={
                                        checkedFacilityId === AllFacilities.id
                                      }
                                      onChange={handleChange}
                                      value={AllFacilities.id.toString()}
                                      label={AllFacilities.name}
                                    />
                                  ))
                                ) : (
                                  <Typography>該当なし</Typography>
                                )}
                              </FormGroup>
                            </>
                          ),
                          align: "left",
                        },
                        {
                          align: "left",
                          children: (
                            <>
                              <FormGroup>
                                {AllFacilities.filter(
                                  (AllFacilities) =>
                                    AllFacilities.category ===
                                      LoopList.AccordionHead &&
                                    AllFacilities.partitioncode === "3"
                                ).length > 0 ? (
                                  AllFacilities.filter(
                                    (AllFacilities) =>
                                      AllFacilities.category ===
                                        LoopList.AccordionHead &&
                                      AllFacilities.partitioncode === "3"
                                  ).map((AllFacilities) => (
                                    <TkRadio
                                      key={AllFacilities.id}
                                      checked={
                                        checkedFacilityId === AllFacilities.id
                                      }
                                      onChange={handleChange}
                                      value={AllFacilities.id.toString()}
                                      label={AllFacilities.name}
                                    />
                                  ))
                                ) : (
                                  <Typography>該当なし</Typography>
                                )}
                              </FormGroup>
                            </>
                          ),
                        },
                      ],
                    ]}
                    headList={FacilityHead}
                  />
                </TkAccordion>
              ) : (
                <TkAccordion title={LoopList.AccordionHead}>
                  <TkTable
                    bodyList={[
                      [
                        {
                          children: (
                            <>
                              <FormGroup>
                                {AllFacilities.filter(
                                  (AllFacilities) =>
                                    AllFacilities.category ===
                                      LoopList.AccordionHead &&
                                    AllFacilities.partitioncode === "1"
                                ).length > 0 ? (
                                  AllFacilities.filter(
                                    (AllFacilities) =>
                                      AllFacilities.category ===
                                        LoopList.AccordionHead &&
                                      AllFacilities.partitioncode === "1"
                                  ).map((AllFacilities) => (
                                    <TkRadio
                                      key={AllFacilities.id}
                                      checked={
                                        checkedFacilityId === AllFacilities.id
                                      }
                                      onClick={handleClick}
                                      onChange={handleChange}
                                      value={AllFacilities.id.toString()}
                                      label={AllFacilities.name}
                                    />
                                  ))
                                ) : (
                                  <Typography>該当なし</Typography>
                                )}
                              </FormGroup>
                            </>
                          ),
                        },
                        {
                          children: (
                            <>
                              <FormGroup>
                                {AllFacilities.filter(
                                  (AllFacilities) =>
                                    AllFacilities.category ===
                                      LoopList.AccordionHead &&
                                    AllFacilities.partitioncode === "3"
                                ).length > 0 ? (
                                  AllFacilities.filter(
                                    (AllFacilities) =>
                                      AllFacilities.category ===
                                        LoopList.AccordionHead &&
                                      AllFacilities.partitioncode === "3"
                                  ).map((AllFacilities) => (
                                    <TkRadio
                                      key={AllFacilities.id}
                                      checked={
                                        checkedFacilityId === AllFacilities.id
                                      }
                                      onClick={handleClick}
                                      onChange={handleChange}
                                      value={AllFacilities.id.toString()}
                                      label={AllFacilities.name}
                                    />
                                  ))
                                ) : (
                                  <Typography>該当なし</Typography>
                                )}
                              </FormGroup>
                            </>
                          ),
                        },
                        {
                          children: (
                            <>
                              <FormGroup>
                                {AllFacilities.filter(
                                  (AllFacilities) =>
                                    AllFacilities.category ===
                                      LoopList.AccordionHead &&
                                    AllFacilities.partitioncode === "2"
                                ).length > 0 ? (
                                  AllFacilities.filter(
                                    (AllFacilities) =>
                                      AllFacilities.category ===
                                        LoopList.AccordionHead &&
                                      AllFacilities.partitioncode === "2"
                                  ).map((AllFacilities) => (
                                    <TkRadio
                                      key={AllFacilities.id}
                                      checked={
                                        checkedFacilityId === AllFacilities.id
                                      }
                                      onClick={handleClick}
                                      onChange={handleChange}
                                      value={AllFacilities.id.toString()}
                                      label={AllFacilities.name}
                                    />
                                  ))
                                ) : (
                                  <Typography>該当なし</Typography>
                                )}
                              </FormGroup>
                            </>
                          ),
                        },
                      ],
                    ]}
                    headList={FacilityHead}
                  />
                </TkAccordion>
              )}
            </Box>
          ))}
        </FormControl>
      </TkModalButton>
      {rest.error && <FormHelperText error>{rest.errorMessage}</FormHelperText>}
    </Box>
  );
};

export default TkFacilitySelection;
